import { useCart } from "@/context/cart";
import { useCheckout } from "@/context/checkout";
import { handleSignOut } from "@/helpers/common/handleSignout";
import { useSession } from "next-auth/react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

function UserInfoBar() {
  const { data } = useSession();
  const user = data?.user;
  const { t } = useTranslation("common");
  const { push } = useRouter();
  const { dispatch: dispatchCart } = useCart();
  const { dispatch: dispatchCheckout } = useCheckout();
  return (
    <div className="flex justify-between">
      <div className="flex flex-col">
        <p className="font-bold max-sm:text-sm md:text-xl">{user?.firstname}</p>
        <p className="text-gray-400 max-sm:text-xs md:text-dark-green md:text-lg">
          {user?.email}
        </p>
      </div>
      {user && (
        <button
          onClick={() => {
            handleSignOut(push, dispatchCart, dispatchCheckout, data);
          }}
          className="px-4 sm:px-12 text-xs sm:text-sm text-center text-white bg-warning  hover:bg-warning md:text-[15px] font-bold sm:py-2"
        >
          {t("Logout")}
        </button>
      )}
    </div>
  );
}

export default UserInfoBar;
